import type { IconSvgObject } from './types';

const Clock03Icon: IconSvgObject = [
  ["path", { d: "M18.952 8.60639L21.4621 8.45358C19.6628 3.70459 14.497 0.999731 9.46036 2.34456C4.09594 3.77692 0.909585 9.26089 2.34343 14.5933C3.77727 19.9258 9.28834 23.0874 14.6528 21.6551C18.6358 20.5916 21.418 17.2945 22 13.4842", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 7.99982V11.9998L14 13.9998", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Clock03Icon;
